// ** React Imports
import { App as CapacitorApp } from '@capacitor/app';
import { Suspense, lazy } from 'react'

// Universal Back Button Handler (Native App + Mobile Browser)
const handleBackNavigation = () => {
  const path = window.location.pathname.replace(/\/$/, ""); 
  
  // Normalized check for all primary entry points to exit the app
  const isExitPath = path === '/user-login' || 
                     path === '/dashboard' || 
                     path === '/dashboard/home' || 
                     path === '' || 
                     path === '/' || 
                     path.includes('/user-login');

  if (isExitPath) {
    try { 
      // Use direct bridge for maximum reliability
      if (window.Capacitor?.Plugins?.App) {
        window.Capacitor.Plugins.App.exitApp();
      } else {
        CapacitorApp.exitApp(); 
      }
    } catch (e) { 
      console.error("Exit failed", e);
    }
    return;
  } 



  // Force a back navigation in history
  window.history.back();
  
  // Fallback for SPA routing issues (Only if NOT on an exit path)
  setTimeout(() => {
      if (window.location.pathname === path) {
          window.location.href = '/dashboard';
      }
  }, 150);
};


// 1. Capacitor Native Listener (Force-Fed from MainActivity)
CapacitorApp.addListener('appBackButton', (data) => {
    handleBackNavigation();
});

document.addEventListener('backbutton', () => {
    handleBackNavigation();
}, false);



// 2. Standard Browser Listener
window.addEventListener('popstate', (event) => {
    console.log("Browser Popstate");
});





import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store, persistor } from './redux/storeConfig/store'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { ToastContainer } from 'react-toastify'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'
import { IntlProviderWrapper } from './utility/context/Internationalization'
// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'
import { PersistGate } from 'redux-persist/integration/react';
// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

import 'utility/axios.js'
import './configs/googelTagManager'

import 'react-loading-skeleton/dist/skeleton.css'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<Spinner />}>
        <AbilityContext.Provider value={ability}>
          <ThemeContext>
            <IntlProviderWrapper>
              <LazyApp />
              <ToastContainer newestOnTop />
            </IntlProviderWrapper>
          </ThemeContext>
        </AbilityContext.Provider>
      </Suspense>
    </PersistGate>
  </Provider>
  ,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
